import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SITE } from '../data/site';
import './NotFound.css';

export function NotFound() {
  useEffect(() => {
    document.title = `Game over — ${SITE.name}`;
  }, []);

  return (
    <section className="nf shell">
      <p className="nf__code">404</p>
      <h1 className="nf__title">GAME OVER</h1>
      <p className="nf__body">
        That cartridge isn&rsquo;t in the cabinet. Insert coin and pick another.
      </p>
      <div className="nf__actions">
        <Link className="btn" to="/">
          BACK TO START &#9656;
        </Link>
        <a className="btn btn--ghost" href={SITE.appUrl}>
          ENTER THE ARCADE
        </a>
      </div>
    </section>
  );
}
